export const VerificationAgencyContacts = `VerificationAgencyContact/Contact/`;
export const CreateContact = VerificationAgencyContacts + 'Create';
export const UpdateContact = VerificationAgencyContacts + 'Update';
export const SearchContacts = 'VerificationAgencyContact/Search';

//Contact External Page (Application page sent to clients)
export const GetContactExternalPage = VerificationAgencyContacts + 'ContactExternalpage';
export const CreateExternalPage = VerificationAgencyContacts + 'CreateExternalPage';
export const UpdateExternalPage = VerificationAgencyContacts + 'UpdateExternalPage';
export const SearchContactsExternalPage = 'VerificationAgencyContact/SearchExternalPage';
export const DeleteExternalEntry = VerificationAgencyContacts + '/';
export const GetContactList = VerificationAgencyContacts + 'ContactNames/';